import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';


import Reviews from './components/Reviews/Review';
import MakeReviews from './components/Reviews/MakeReview';
import TopRated from './components/Reviews/TopRated';
import Marketplace from './components/marketplace/Marketplace';
import About from './components/about/AboutUs';

import Public from './components/Public';
import NotFound from './components/NotFound';
// import UserSignUp from './components/user/UserSignUp';
// import UserSignIn from './components/user/UserSignIn';
// import UserSignOut from './components/user/UserSignOut';
// import Authenticated from './components/Authenticated';
// import PrivateRoute from './components/PrivateRoute';
import withContext from './components/Context';

import Header from './components/temps/Header';


const MarketplaceWithContext = withContext(Marketplace);
const ReviewsWithContext = withContext(Reviews);
const TopRatedWithContext = withContext(TopRated);
const MakeReviewsWithContext = withContext(MakeReviews);
const AboutWithContext = withContext(About);

const HeaderWithContext = withContext(Header);
// const AuthWithContext = withContext(Authenticated);
// const UserSignUpWithContext = withContext(UserSignUp);
// const UserSignInWithContext = withContext(UserSignIn);
// const UserSignOutWithContext = withContext(UserSignOut);

const appRoutes = () => (
    <Router>
      <div>
        <HeaderWithContext />
        <Switch>
        <Route exact path="/" component={Public} />
        {/* <PrivateRoute path="/authenticated" component={AuthWithContext} /> */}
        <Route exact path="/marketplace" component={MarketplaceWithContext} />
        <Route exact path="/reviews" component={ReviewsWithContext} />
        <Route exact path="/reviews/reviewcom" component={MakeReviewsWithContext} />
        <Route exact path="/reviews/toprated" component={TopRatedWithContext} />
        <Route exact path="/about" component={AboutWithContext} />
        {/* <Route path="/signin" component={UserSignInWithContext} />
        <Route path="/signup" component={UserSignUpWithContext} />
        <Route path="/signout" component={UserSignOutWithContext} /> */}
        <Route component={NotFound} />
        </Switch>
    </div>
  </Router>
);

export default appRoutes;